import React from 'react';
import PropTypes from 'prop-types';

import {
  BreadcrumbsProvider,
  Breadcrumbs,
} from 'components/shared/Breadcrumbs';
import ThemeProvider from './ThemeProvider.react';
import Header from './Header.react';
import Footer from './Footer.react';

import './App.css';

const Layout = (props) => {
  return (
    <BreadcrumbsProvider>
      <ThemeProvider>
        <Header />
        {React.createElement(Breadcrumbs, props)}
        <div role="main">{props.children}</div>
        <Footer />
      </ThemeProvider>
    </BreadcrumbsProvider>
  );
};

Layout.propTypes = {
  children: PropTypes.node,
};

export default Layout;
